import { ResponseReqManagerCreate, RequestManagerCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { ReqManagerCreateActions } from '../actions';
import { ReqManagerCreateTypes } from '../../shared/enums';

export interface ReqManagerCreateState {
    response: ResponseReqManagerCreate;
    request: RequestManagerCreate;
    error: any;
}

export const ReqManagerCreateInitialState: ReqManagerCreateState = {
    response: null,
    request: null,
    error: null
};

const _reqManagerCreateReducer = createReducer(
    ReqManagerCreateInitialState,

    on(ReqManagerCreateActions.getReqManagerCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(ReqManagerCreateActions.getReqManagerCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(ReqManagerCreateActions.getReqManagerCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(ReqManagerCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function reqManagerCreateReducer(state, action) {
    if (action.type === ReqManagerCreateTypes.REQUEST_MANAGER_CREATE) {
        state = undefined;
    }
    return _reqManagerCreateReducer(state, action);
}
